/***
*
*   DASHBOARD
*   Template dashboard example demonstrating various components inside a view.
*
**********/

import React, { useState, useEffect } from 'react';
import { Card, Chart, useAPI, ConnectionSummary } from 'components/lib';
import { Animate } from 'components/animate/animate';
import { useSocket } from 'app/socketContext';
import { SyncModalEmbedded } from 'components/lib/SyncToast';
import GaugeChart from 'react-gauge-chart'
import { CleanupSummary } from './CleanupSummary';
import styles from './index.module.css';

export function Dashboard(props){

  const appConnections = useAPI('/api/app_connection');
  // const stats = useAPI('/api/appData/execMetrics');
  const dataSummary = useAPI('/api/appData/dataProcessedChart');
  // const auditData = useAPI('/api/auditRule/resultsSummary');
  // const backupData = useAPI('/api/appData/dataProcessedSummary');
  const healthScore = useAPI('/api/appData/healthScore');
  const connectionSummary = useAPI('/api/appData/connectionSummary');
  
  const [connSummary, setConnSummary] = useState(null);
  const [connSummaryTitle, setConnSummaryTitle] = useState("");
  const [dataFlowing, setDataFlowing] = useState(true);

  const { syncState } = useSocket();




  useEffect(() => {
    console.log(JSON.stringify(connectionSummary))
    setConnSummary(connectionSummary.data)

    var title = 'No data flowing from system yet. Please wait.';

    if(connectionSummary?.data) {
      if(connectionSummary?.data?.co_name !== "") {
        title = connectionSummary.data?.co_name + ' is connected to ' + connectionSummary.data?.app_name
      }

      if(connectionSummary?.data?.notif !== "") {
        title = title + " with alerts sent to " + connectionSummary.data?.notif;
      }

      setDataFlowing(true);
      // Clear the flag since data is flowing
      localStorage.removeItem('dashboard_no_data_flowing');
    } else {
      setDataFlowing(false);
      // Set flag to indicate dashboard is in no-data-flowing state
      localStorage.setItem('dashboard_no_data_flowing', 'true');
    }
    setConnSummaryTitle(title);

  }, [connectionSummary]);

  // Clear the flag when component unmounts (user navigates away from dashboard)
  useEffect(() => {
    return () => {
      localStorage.removeItem('dashboard_no_data_flowing');
    };
  }, []);

  return (
    <Animate type='pop'>

{appConnections.data?.length === 0 ? 
  <Card 
        
        loading={appConnections?.loading}
      >
        <div className={styles.emptyStateCard}>
          <div className={styles.emptyStateText}>
            <h2>Setup your first application data connection to begin using LedgerView</h2>
          </div>
        </div>
        <div className={styles.emptyStateLinks}>
          <h2><a href='/client/connections'>App Connections</a></h2>
        </div>
  </Card>

: 

dataFlowing === false ? 
  <Card 
        
        loading={appConnections?.loading}
      >
        {syncState.isActive ? (
          <div className={styles.syncContainer}>
            <h2>Syncing your data...</h2>
            <SyncModalEmbedded 
              onClose={() => {}} // Don't allow closing during sync
              syncStatus={syncState.status}
              currentMessage={syncState.currentMessage}
              appName={syncState.appName}
              progress={syncState.progress}
              syncHistory={syncState.history}
              currentStage={syncState.currentStage}
            />
          </div>
        ) : (
          <>
            <div className={styles.emptyStateCard}>
              <h2>No data is detected yet. LedgerView will track changes as they happen in your connected apps.</h2>
            </div>
            <div className={styles.emptyStateLinks}>
              <h2><a href='/client/connections'>App Connections</a></h2>
            </div>
          </>
        )}
  </Card>

:

<>
<ConnectionSummary 
        connectionSummary={connectionSummary}
        connSummaryTitle={connSummaryTitle}
        connSummary={connSummary}
      />


    <div className={styles.dashboardContainer}>
      <div className={styles.chartSection}>
      
      

      

      <Card name='history'>
        <Chart
          type='line'
          legend
          loading={ dataSummary.loading }
          data={ dataSummary.data }
          color={['blue', 'green', 'red']}
        />
      </Card>
      </div>
      <div className={styles.sidebarSection}>
        <Card 
          title="Health Score" 
          loading={appConnections?.loading} 
          center={true}
          className={styles.healthScoreCard}
        >
          <div className={styles.healthScoreButton}>
            <a 
              href="/healthScore" 
              className={styles.healthScoreLink}
            >
              Details
            </a>
          </div>
          <div className={styles.gaugeContainer}>
          <GaugeChart id="gauge-chart5"
            nrOfLevels={100}
            arcsLength={[0.3, 0.5, 0.2]}
            colors={['#EA4228', '#F5CD19', '#5BE12C']}
            percent={healthScore.data}
            arcPadding={0.02}
            textColor='#000000'
            formatTextValue={value => `${Math.round(value)}/100`}
          />
          {/* <HorizontalBar
          loading={ backupData?.loading }
          data={ backupData?.data }
          color={['red', 'blue']}
        /> */}
          </div>
        </Card>
        </div>
      </div>

      {/* <ClientPastMonthCloses /> */}
 
      <CleanupSummary />
      </>
}

      {/* <Feedback /> */}

    </Animate>
  );
}
